// extracted by mini-css-extract-plugin
export default {"layouts-menu":"LayoutsMenu_layouts-menu__bjHL4","layouts-menu--open":"LayoutsMenu_layouts-menu--open__06iWQ","layouts-menu__options":"LayoutsMenu_layouts-menu__options__c9Du3"};